import styled from 'styled-components';

export const StyledChartekForm = styled.form`
  margin: 1rem;
`;
